<template>
    <BRow v-if="enrollments">
      <BCol cols="12" v-if="showEnrol">
        <BCard>
          <BRow>
            <BCol cols="12" md="3">
              <h4 class="mb-2">{{$t('Enrollments')}}</h4>
            </BCol>
            <BCol cols="12" md="9">
                <BButton variant="primary" :to="{ name: 'enrollments' }" class="float-right mb-2" size="sm"> {{ $t("Manage enrollments") }} </BButton>
                <BButton variant="primary" :to="{ name: 'enrollments-add' }" class="float-right mb-2 mr-1" size="sm">{{ $t('Create enrollment') }}</BButton>
            </BCol>
          </BRow>
          <Transition name="fade">
            <BTable id="enrollments"  responsive="xl" :items="enrollments.data" :fields="enrollmentCols" @row-selected="onRowSelected" show-empty :empty-text="$t('No enrollments')">
              <template #cell(code)="data">
                <BLink :to="{ name: 'enrollments-view', params: { id: data.item.id } }"  class="font-weight-bold d-block text-nowrap"> {{ data.item.code }} </BLink>
              </template>

              <template #cell(dates)="data">
                  <small>
                    <span><b>Desde: </b>{{ format(new Date (data.item.start_date), 'dd-MM-yyyy') }}</span><br>
                    <span><b>Hasta: </b>{{ data.item.end_date ? format(new Date (data.item.end_date), 'dd-MM-yyyy') : '(No definida)' }}</span>
                  </small>
              </template>

              <template #cell(expiration_date)="data">
                    <span v-if="data.item.expiration_date">{{ format(new Date (data.item.expiration_date), 'dd-MM-yyyy') }}</span>
                    <span v-else>-</span>
              </template>

              <template #cell(status)="data">
                <BFormCheckbox id="checkbox-status" v-model="data.item.status" disabled />
              </template>

              </BTable>
          </Transition>
          <BPagination v-model="enrollments.current_page" :total-rows="enrollments.total" :per-page="enrollments.per_page" aria-controls="enrollments" class="pagination-primary" @input="onPageChange" />
        </BCard>
      </BCol>
    </BRow>
  </template>

<script>
  import { BCard, BButton, BAvatar, BRow, BCol, BTable, BPagination, BFormCheckbox, BLink } from 'bootstrap-vue'
  import { avatarText } from '@core/utils/filter'
  import { inject, ref, computed } from '@vue/composition-api'
  import i18n from '@/libs/i18n'
  import axios from '@axios'
  import { format } from 'date-fns';
  import currency from '@/utils/currency'
  import useInvoicesList from '../../invoices/invoices-list/useInvoicesList'

  export default {
    components: { BCard, BButton, BRow, BCol, BAvatar, BTable, BPagination, BFormCheckbox, BLink},
    setup() {
      const { resolveInvoiceStatusVariantAndIcon } = useInvoicesList()
      const { formatCurrency } = currency()
      const student = inject('student')
      const selected = ref([])
      const showEnrol = ref(true)
      const showInvoice = ref(true)
      const enrollments = ref(null)
      const invoices = ref(null)

      const enrollmentCols = [
          { key: 'code', label: i18n.t('Enrollment') },
          { key: 'dates', label: i18n.t('Duración') },
          { key: 'expiration_date', label: i18n.t('Próxima renovación') }, 
          { key: 'status', label: i18n.t('Status') }
      ]

      // { key: 'customer_billing_full_name', label: i18n.t('Student'), sortable: true,  sort: (a, b) => a.localeCompare(b)},

      const invoicesCols = [
          { key: 'name', label: i18n.t('#') },
          { key: 'paid', label: i18n.t('Paid'), sortable:true },
          { key: 'efecto', label: 'Efecto' },
          { key: 'dates', label: i18n.t('Fechas') },
          { key: 'amount', label: i18n.t('Amount') },
          
      ]



      // const computedPaid = computed((paid) => {
      //   return paid === 0 ? false : true;
      // });
      const refetchData = function() {
        let data = {
          id: student.value.id,
          selected: selected.value,
          invoices_page: invoices.value ? invoices.value.current_page : 1,
          enrollments_page: enrollments.value ? enrollments.value.current_page : 1
        }

        axios.post('customer/refresh-table', data).then(response => {
          enrollments.value = response.data.enrollments
          invoices.value = response.data.invoices

          invoices.value.data.forEach((item)=> {
            item.paid_status=item.paid == 0 ? false : true;
          })
          showInvoice.value = true
          showEnrol.value = true
          enrollments.value.data.forEach(enrol => enrol.view_more =  '' )

        })
      }

      refetchData()


      const onRowSelected = function(enrollments) {
        selected.value = enrollments[0]
        showInvoice.value = false
        refetchData()
      }

      const onPageChange = function(){
        selected.value = null
        showEnrol.value = false
        refetchData()
      }



      return {
        avatarText,
        enrollmentCols,
        invoicesCols,
        onPageChange,
        onRowSelected,
        showEnrol,
        showInvoice,
        enrollments,
        invoices,
        selected, 
        format,
        formatCurrency,
        resolveInvoiceStatusVariantAndIcon
      }
    },
  }
</script>

<style lang="scss">
  @import 'src/assets/scss/variables/_variables.scss';
  [dir] .table.b-table > tbody .b-table-row-selected.table-active td {
    background-color: $primary;
    color:white
  }

  [dir] .table.b-table > tbody .b-table-row-selected.table-active td a {
    background-color: $primary;
    color:white
  }

  @media (max-width: 1300px){
    .table-responsive-xl {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
  }

</style>
